// MARK://dhk8/admin-shell/lib/queries/users
// Queries tipadas de staff/usuarios — F3.2 / ADR-0009. El Admin lee el personal por
// el grafo (platform-auth), tenant del JWT. Escrituras (crear/editar/rol/PIN/borrar)
// + passkeys siguen REST. NUNCA expone hash/credenciales.
import { graphql } from '../../gql/index.js'

export const AdminStaffUsersQuery = graphql(`
  query AdminStaffUsers($role: String) {
    staffUsers(role: $role) {
      id
      email
      fullName
      role
      status
      pinId
      hasManagerPin
      createdAt
    }
  }
`)

export const AdminStaffUserQuery = graphql(`
  query AdminStaffUser($id: ID!) {
    staffUser(id: $id) {
      id
      email
      fullName
      role
      status
      pinId
      hasManagerPin
      createdAt
    }
  }
`)


// F6.2 R3d: gestión de staff (crear/editar/rol/borrar/PIN) por el grafo.
// Acciones de AUTORIDAD/privilegio — gating server-side con el MISMO permiso
// RBAC de la ruta REST (platform-auth:user:{create,update,delete}@*). Reemplazan
// POST/PUT/DELETE /api/users[/:id[/role]] y PUT /v1/users/:id/pin.
export const CreateStaffUserMutation = graphql(`
  mutation CreateStaffUser($input: CreateStaffUserInput!) {
    createStaffUser(input: $input) {
      user { id email fullName role status pinId hasManagerPin createdAt }
      pin
    }
  }
`)

export const UpdateStaffUserMutation = graphql(`
  mutation UpdateStaffUser($id: ID!, $input: UpdateStaffUserInput!) {
    updateStaffUser(id: $id, input: $input) {
      id email fullName role status pinId hasManagerPin createdAt
    }
  }
`)

export const SetStaffUserRoleMutation = graphql(`
  mutation SetStaffUserRole($id: ID!, $role: String!) {
    setStaffUserRole(id: $id, role: $role) {
      id email fullName role status pinId hasManagerPin createdAt
    }
  }
`)

export const DeleteStaffUserMutation = graphql(`
  mutation DeleteStaffUser($id: ID!) {
    deleteStaffUser(id: $id) {
      id
      status
    }
  }
`)

export const SetStaffUserPinMutation = graphql(`
  mutation SetStaffUserPin($id: ID!, $pinId: String!, $pin: String, $managerPin: String) {
    setStaffUserPin(id: $id, pinId: $pinId, pin: $pin, managerPin: $managerPin) {
      userId
      pinId
    }
  }
`)
